module.exports = __webpack_public_path__ + "img/banner-01.6fda263a.png";